import { Link } from 'react-router-dom';
import styled from 'styled-components';

const panel = `
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 18px 50px rgba(12, 37, 84, 0.08);
`;

export const IndexWrap = styled.section`
  ${panel};
  width: 100%;
  max-width: 1040px;
  margin: 48px auto 80px;
  padding: 48px;
  line-height: 1.6;
  color: #14315f;

  h1 {
    margin: 0 0 12px;
    font-size: 36px;
    line-height: 1.15;
  }

  p {
    margin: 0 0 16px;
    font-size: 17px;
  }

  a {
    color: #0e3182;
    font-weight: 700;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: 768px) {
    margin: 24px auto 48px;
    padding: 24px 20px;

    h1 {
      font-size: 28px;
    }
  }
`;

export const Meta = styled.p`
  display: inline-flex;
  align-items: center;
  margin: 0 0 32px;
  padding: 10px 14px;
  border-radius: 999px;
  background: #edf4ff;
  color: #0e3182;
  font-size: 14px;
  font-weight: 700;
`;

export const IndexGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-bottom: 32px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const IndexCard = styled(Link)`
  display: block;
  padding: 24px;
  border: 1px solid #d6e4ff;
  border-radius: 18px;
  background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
  color: #14315f;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 32px rgba(14, 49, 130, 0.12);
    text-decoration: none;
  }

  .eyebrow {
    display: inline-block;
    margin-bottom: 12px;
    color: #0e3182;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  h2 {
    margin: 0 0 12px;
    font-size: 24px;
    line-height: 1.25;
  }

  .action {
    display: inline-block;
    margin-top: 16px;
    font-weight: 700;
  }
`;

export const IndexDescription = styled.p`
  margin: 0;
  color: #34507f;
  font-size: 15px;
`;

export const DocumentWrap = styled.article`
  ${panel};
  width: 100%;
  max-width: 960px;
  margin: 48px auto 80px;
  padding: 48px;
  line-height: 1.7;
  color: #1a2740;
  font-size: 16px;

  .backLink {
    display: inline-block;
    margin-bottom: 24px;
    color: #0e3182;
    font-weight: 700;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  h1 {
    margin: 0 0 8px;
    font-size: 34px;
    line-height: 1.2;
    color: #10264a;
  }

  h2 {
    margin: 16px 0 8px;
    font-size: 24px;
    line-height: 1.3;
    color: #10264a;
  }

  h3 {
    margin: 28px 0 10px;
    font-size: 19px;
    line-height: 1.35;
    color: #0e3182;
  }

  p {
    margin: 0 0 14px;
  }

  ul {
    margin: 0 0 18px;
    padding-left: 24px;
  }

  li {
    margin-bottom: 8px;
  }

  strong {
    color: #10264a;
  }

  @media screen and (max-width: 768px) {
    margin: 24px auto 48px;
    padding: 24px 20px;
    font-size: 15px;

    h1 {
      font-size: 28px;
    }

    h2 {
      font-size: 22px;
    }

    h3 {
      font-size: 18px;
    }
  }
`;
